import { commonLocale } from "./common";
const locale = {
  ...commonLocale,
  locale: 'zh_TW',
  today: '今天',
  now: '此刻',
  backToToday: '返回今天',
  ok: '確定',
  timeSelect: '選擇時間',
  dateSelect: '選擇日期',
  weekSelect: '選擇周',
  clear: '清除',
  week: '週',
  month: '月',
  year: '年',
  previousMonth: '上個月',
  nextMonth: '下個月',
  monthSelect: '選擇月份',
  yearSelect: '選擇年份',
  decadeSelect: '選擇年代',
  yearFormat: 'YYYY年',
  previousYear: '上一年',
  nextYear: '下一年',
  previousDecade: '上一年代',
  nextDecade: '下一年代',
  previousCentury: '上一世紀',
  nextCentury: '下一世紀',
  cellDateFormat: 'D',
  monthBeforeYear: false
};
export default locale;